module.exports = __webpack_public_path__ + "static/media/cairn-homes.34a66040.png";